import $http from '@/0/Libs/HttpHelper.js'
import $msg from '@/0/Libs/MessageHelper.js'

export default {

  async getReportTest(sn) {
    if (!sn) {
      $msg.error("Sn序列码不能为空.");
      return null;
    }

    var url = '/mTmsApi/ProductSn/Get';
    var postData = {
      Sn: sn,
    }
    let { data: result } = await $http({
      url: url,
      method: "post",
      data: postData,
    });

    if (result.state != 1) {
      $msg.fail(result.$msg);
      return result;
    }
    return result;
  },

  async getReportStandard(sn) {
    if (!sn) {
      $msg.error("Sn序列码不能为空.");
      return null;
    }

    var url = '/mTmsApi/ProductSn/GetGB';
    var postData = {
      Sn: sn,
    }
    let { data: result } = await $http({
      url: url,
      method: "post",
      data: postData,
    });

    if (result.state != 1) {
      $msg.fail(result.$msg);
      return result;
    }
    return result;
  },

}


